import React, { FC } from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import styled from 'styled-components';

import { authSelectors, impersonateSelectors } from '../../../store';
import { NgRailItem } from '../NgRailItem/NgRailItem';
import { NgCard, NgCardContent } from '../NgCard/NgCard';
import { AccessGuard } from '../../AccessGuard/AccessGuard';

const Sidebar = styled.ul`
  min-width: 200px;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  list-style: none;
  margin: 0;
  padding: 0;
`;

export const NgSubPagesNav: FC<{ sideNavItems: NgSubPagesNavItem[] }> = ({ sideNavItems }) => {
  const activeUser = useSelector(authSelectors.getUserAuthState)?.user;
  const impersonatedUser = useSelector(impersonateSelectors.getImpersonatedUser);

  return (
    <NgCard>
      <NgCardContent>
        <Sidebar>
          {sideNavItems.map((item) => {
            const hasAcess =
              AccessGuard.check({ allowedRoles: item?.accessRoles || [], user: activeUser }) || impersonatedUser;

            return (
              hasAcess && (
                <NavLink key={item.id} to={item.to}>
                  {({ isActive }) => (
                    <NgRailItem title={item.displayName} className={classNames({ active: isActive })} />
                  )}
                </NavLink>
              )
            );
          })}
        </Sidebar>
      </NgCardContent>
    </NgCard>
  );
};
